import { Box, type BoxProps } from '@mui/material';

type ColorDotProps = {
  color: string;
  sizeOverride?: string;
} & BoxProps;

export const ColorDot: React.FC<ColorDotProps> = ({ color, sizeOverride, ...boxProps }) => {
  return (
    <Box
      sx={{
        ...boxProps.sx,
        height: sizeOverride ?? '12px',
        width: sizeOverride ?? '12px',
        borderRadius: '100%',
        backgroundColor: color,
      }}
      {...boxProps}
    />
  );
};
